(function($) {
	var $menu = $('.ct-component-meganavigation');
	var sticky = $menu.offset().top;

	function checkNavigationStickyStatus()
	{
		if (window.pageYOffset >= sticky) {
			$menu.addClass("sticky");
			$('body').addClass("nav-is-sticky");
		} else {
			$menu.removeClass("sticky");
			$('body').removeClass("nav-is-sticky");
		}
	}

	$(window).scroll(checkNavigationStickyStatus);
	$(document).ready(checkNavigationStickyStatus);
}(jQuery));